import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/legal/privacidad/page.tsx");
